import type { PendingChatJob } from './chatTypes'

const KEY = 'monstera_pwa_pending_chat_job'
const MAX_AGE = 30 * 60 * 1000

export const pendingJobStorage = {
  read(): PendingChatJob | null {
    try {
      const value = JSON.parse(sessionStorage.getItem(KEY) || 'null') as PendingChatJob | null
      if (!value?.jobId || !value.userId || !value.userMessage || !value.thinkingMessage || Date.now() - value.createdAt > MAX_AGE) { this.clear(); return null }
      return value
    } catch { this.clear(); return null }
  },
  write(job: PendingChatJob) { sessionStorage.setItem(KEY, JSON.stringify(job)) },
  clear() { sessionStorage.removeItem(KEY) }
}
